// extracted by mini-css-extract-plugin
export var li = "_tt-2";
export var ol = "_tt-1";
export var ul = "_tt-0";